import { RouterStore } from 'mobx-react-router';
import React from 'react';

export const routingStore = new RouterStore();
export const Context = React.createContext({ routing: routingStore });
